import React from 'react';
import { CheckIcon, CreditCardIcon, DownloadIcon, InfinityIcon, ShieldCheckIcon } from 'lucide-react';
import { BONUS_VALUE, DISCOUNT_PERCENT, HERO_IMAGE, REGULAR_PRICE, SALE_PRICE, TOTAL_VALUE, offerIncludes } from '../data/content';
import { OFFER_SIZES, OFFER_WIDTHS, optimizedImage, optimizedSrcSet } from '../utils/images';
import { CHECKOUT_URL, CtaButton } from './CtaButton';
import { Accent, SectionHeading } from './SectionHeading';
import { Reveal } from './Reveal';
const trustBadges = [{
  icon: CreditCardIcon,
  label: 'One-time payment'
}, {
  icon: InfinityIcon,
  label: 'Lifetime access'
}, {
  icon: DownloadIcon,
  label: 'Instant download'
}, {
  icon: ShieldCheckIcon,
  label: '7-day guarantee'
}];
export function OfferSection() {
  return <section id="offer" className="w-full scroll-mt-4 border-y border-white/5 bg-steel-900 px-6 py-16 sm:py-20" aria-labelledby="offer-title" data-id="element-118" data-mp="wan72awnxyt6">
      <div className="mx-auto max-w-6xl" data-id="element-119" data-mp="2y3kutsbl2179">
        <SectionHeading id="offer-title" title={<>
              Regular price ${REGULAR_PRICE}. <Accent data-id="element-121" data-mp="12otf1flef9hy">Yours today for ${SALE_PRICE}.</Accent>
            </>} subtitle={`A ${TOTAL_VALUE} value stack that normally sells for ${REGULAR_PRICE}. Educators usually pay for their own materials — that is exactly why the launch price is ${SALE_PRICE}.`} data-id="element-120" data-mp="2y6gq18w1qbs0" />

        <div className="mt-10 grid items-center gap-8 lg:grid-cols-[1fr_1fr] lg:gap-12" data-id="element-122" data-mp="owwrzpyl7psf">
          <Reveal className="relative mx-auto w-full max-w-md" data-id="element-123" data-mp="1lmw8c6kzbslk">
            <img src={optimizedImage(HERO_IMAGE, 560)} srcSet={optimizedSrcSet(HERO_IMAGE, OFFER_WIDTHS)} sizes={OFFER_SIZES} alt="Everything included: six core volumes, six bonus guides and printable classroom worksheets" width={1000} height={1000} loading="lazy" decoding="async" className="h-auto w-full drop-shadow-[0_24px_48px_rgba(0,0,0,0.8)]" data-id="element-124" data-mp="1lk0ccnsozdzr" />
            <span className="absolute -right-1 top-1 flex h-20 w-20 flex-col items-center justify-center bg-ember-500 font-display font-bold leading-none text-steel-950 sm:h-24 sm:w-24" data-id="element-125" data-mp="17kieozclfpl">
              <span className="text-2xl sm:text-3xl" data-id="element-126" data-mp="3ttpzsepixvfc">{DISCOUNT_PERCENT}%</span>
              <span className="mt-1 text-[0.6rem] uppercase tracking-[0.18em]" data-id="element-127" data-mp="2ng946i1xiet">Off</span>
            </span>
          </Reveal>

          <Reveal index={1} data-id="element-128" data-mp="3ks9pe6ypltb4">
            <div className="border border-white/[0.09] bg-steel-850 px-6 py-8 text-center sm:px-9" data-id="element-129" data-mp="3kt1lrk04rv2g">
              <dl className="mx-auto grid max-w-xs gap-1.5 text-sm" data-id="element-130" data-mp="3ot3eh3nw1e5l">
                <div className="flex items-baseline justify-between gap-4" data-id="element-131" data-mp="3b2gp4240p0m6">
                  <dt className="text-ink-400" data-id="element-132" data-mp="3fuqd3clknqlt">Core system · 6 volumes</dt>
                  <dd className="text-ink-200" data-id="element-133" data-mp="3fw1cl07zic74">${REGULAR_PRICE}</dd>
                </div>
                <div className="flex items-baseline justify-between gap-4" data-id="element-134" data-mp="31394quyv85pk">
                  <dt className="text-ink-400" data-id="element-135" data-mp="364yco1qsk39f">6 instructor bonuses</dt>
                  <dd className="text-ink-200" data-id="element-136" data-mp="2s4dy5hrwstlq">${BONUS_VALUE}</dd>
                </div>
                <div className="mt-1 flex items-baseline justify-between gap-4 border-t border-white/[0.08] pt-2 text-xs font-semibold uppercase tracking-[0.14em]" data-id="element-137" data-mp="2x48l5a8kcz1i">
                  <dt className="text-ink-500" data-id="element-138" data-mp="2djrwgm51xdum">Total value</dt>
                  <dd className="text-ink-200" data-id="element-139" data-mp="28k5ho89krpjp">${TOTAL_VALUE}</dd>
                </div>
                <div className="flex items-baseline justify-between gap-4 text-xs font-semibold uppercase tracking-[0.14em]" data-id="element-140" data-mp="2mjodq2p43afn">
                  <dt className="text-ink-500" data-id="element-141" data-mp="2ifqhq0v32fqt">Regular price</dt>
                  <dd className="text-ink-500 line-through" data-id="element-142" data-mp="2wfrgnarsfd3n">${REGULAR_PRICE}</dd>
                </div>
              </dl>

              <p className="mt-6 font-display text-xs font-semibold uppercase tracking-[0.2em] text-ember-400" data-id="element-143" data-mp="2rh6qy5a5wbtg">
                Launch price today
              </p>
              <p className="mt-1 font-display text-6xl font-bold text-ink-50 sm:text-7xl" data-id="element-144" data-mp="316ztkgsbtglk">
                ${SALE_PRICE}
              </p>
              <p className="mt-2 text-xs uppercase tracking-[0.14em] text-ink-500" data-id="element-145" data-mp="3f7u4p76rdvnx">
                One-time payment · Digital download
              </p>

              <CtaButton className="mt-7" fullWidth href={CHECKOUT_URL} label="Get The Full System Now" source="offer" data-id="element-146" data-mp="18jjzjntl2rwa" />

              <ul className="mx-auto mt-6 grid max-w-sm grid-cols-2 gap-y-2 text-xs text-ink-400" data-id="element-147" data-mp="1dh3d0ligj0n6">
                {trustBadges.map(({
                icon: Icon,
                label
              }) => <li key={label} className="flex items-center justify-center gap-1.5" data-id="element-148" data-mp="1maosy86cyny6">
                    <Icon className="h-3.5 w-3.5 text-circuit-400" aria-hidden="true" data-id="element-149" data-mp="pkplkh1y1vh6" />
                    {label}
                  </li>)}
              </ul>

              <ul className="mt-7 grid gap-2 border-t border-white/[0.08] pt-6 text-left" data-id="element-150" data-mp="uld9uuysfy7p">
                {offerIncludes.map(item => <li key={item} className="flex items-start gap-2 text-sm text-ink-200" data-id="element-151" data-mp="13jxljc5xl7mf">
                    <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-ember-400" strokeWidth={3} aria-hidden="true" data-id="element-152" data-mp="13hkw6dxufuzc" />
                    <span data-id="element-153" data-mp="2eykvhtilza2v">{item}</span>
                  </li>)}
              </ul>
            </div>
          </Reveal>
        </div>
      </div>
    </section>;
}